import styled from 'styled-components';

export const NavbarSindicoContainer = styled.div`
  height: 72px;
  background-color: white;
  display: flex;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid #d1d1d1;
`;
